import { render } from "./Entities-UsersList.vue?vue&type=template&id=142b916b&lang=html"
import script from "./Entities-UsersList.vue?vue&type=script&lang=js"
export * from "./Entities-UsersList.vue?vue&type=script&lang=js"

import "./Entities-UsersList.vue?vue&type=style&index=0&id=142b916b&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__